import { Component, EventEmitter, Input, Output, OnInit, inject, DestroyRef } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IDynamicControlModel } from "../dynamic-control-model";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DateFnsAdapter } from "@angular/material-date-fns-adapter";
import { getYear } from "date-fns";
import { enUS } from "date-fns/locale";
import { ITags } from "../../features/bucket-items/models/bucket-item.model";
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon } from "@angular/material/datepicker";
import { MatFormField, MatInput, MatSuffix } from "@angular/material/input";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: "yyyy",
  },
  display: {
    dateInput: "yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "PP",
    monthYearA11yLabel: "MMMM yyyy",
  },
};

@Component({
    selector: "app-year-picker",
    templateUrl: "./year-picker.component.html",
    styleUrls: ["./year-picker.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: DateFnsAdapter,
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: enUS,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: YEAR_MODE_FORMATS,
        },
    ],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepickerToggleIcon, MatDatepicker, MatIconButton, MatTooltip]
})
export class YearPickerComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @Input() public tag: Partial<IDynamicControlModel>;
  @Input() public initialValue: string;
  @Input() public disabled: boolean = false;
  @Input() public idPrefix?: string;
  @Output() public selectedValue: EventEmitter<Partial<ITags>> =
    new EventEmitter<Partial<ITags>>();

  public dateControlForm: FormGroup = new FormGroup({
    yearControl: new FormControl(""),
  });
  private readonly defaultIdPrefix = "bucket-items-tags-tag-unknown";
  currentYear: number = new Date().getFullYear();
  ngOnInit(): void {
    this.initForm();
    if (this.disabled) {
      this.dateControlForm.disable();
    }
    this.dateControlForm
      .get("yearControl")
      .valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((year: number) => {
        this.selectedValue.emit({
          TagKey: this.tag.TagKey,
          TagValue: year.toString(),
          TagsDisplayOrder: this.tag.TagsDisplayOrder,
        });
      });
  }

  initForm(): void {
    this.dateControlForm.get("yearControl").patchValue(this.initialValue);
  }

  calenderSelected(
    normalizedYear: Date,
    picker: MatDatepicker<Date>
  ): void {
    this.dateControlForm
      .get("yearControl")
      .setValue(getYear(normalizedYear).toString());
    picker.close();
  }

  clearContent(): void {
    if (this.disabled) {
      return;
    }
    this.dateControlForm.get("yearControl").patchValue("");
  }

  disableFutureDate = (d: Date | null) => {
    const year = getYear(d || new Date());
    return year >= 1000 && year <= this.currentYear;
  };

  viewChanged(picker: MatDatepicker<Date>) {
    picker.close();
  }

  public buildElementId(segment: string): string {
    const base = this.idPrefix && this.idPrefix.trim().length > 0 ? this.idPrefix.trim() : this.defaultIdPrefix;
    return `${base}-${segment}`;
  }
}
